import React from 'react';
import { Tabs, FormControl, Select, MenuItem, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const getTabLabel = (tab, index) => {
  if (!React.isValidElement(tab)) return `Tab ${index + 1}`;
  const label = tab.props?.label;
  if (typeof label === 'string' || typeof label === 'number') return label;
  if (tab.props?.['aria-label']) return tab.props['aria-label'];
  return `Tab ${index + 1}`;
};

const ResponsiveTabs = ({
  children,
  value,
  onChange,
  label = 'View',
  selectProps,
  selectSx,
  ...tabsProps
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const { sx, style, ...restTabsProps } = tabsProps;

  const items = React.Children.toArray(children)
    .filter(Boolean)
    .map((child, index) => {
      if (!React.isValidElement(child)) return null;
      const tabValue = child.props?.value ?? index;
      return {
        value: tabValue,
        label: getTabLabel(child, index)
      };
    })
    .filter(Boolean);

  if (isMobile) {
    return (
      <FormControl
        size="small"
        fullWidth
        style={style}
        sx={{
          minWidth: 160,
          flex: 1,
          maxWidth: '100%',
          ...(sx || {}),
          ...(selectSx || {})
        }}
      >
        <Select
          value={value ?? ''}
          onChange={(event) => onChange?.(event, event.target.value)}
          inputProps={{ 'aria-label': tabsProps['aria-label'] || label }}
          {...selectProps}
        >
          {items.map((item) => (
            <MenuItem key={`tab-${item.value}`} value={item.value}>
              {item.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    );
  }

  return (
    <Tabs value={value} onChange={onChange} sx={sx} {...restTabsProps}>
      {children}
    </Tabs>
  );
};

export default ResponsiveTabs;
